/**
 * Internal admin accounts (e.g. admin+clinica@akuna.pet) are system-generated:
 * they must never be shown in the UI, neither their e-mail nor the user itself.
 * Display-only: never use it to alter data.
 */
export function isHiddenInternalEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const value = email.trim().toLowerCase();
  return value.includes("admin") && value.endsWith("@akuna.pet");
}

export function getDisplayEmail(email: string | null | undefined): string | null {
  if (!email) return null;
  return isHiddenInternalEmail(email) ? null : email;
}

export function withoutHiddenUsers<T extends { email?: string | null }>(rows: T[]): T[] {
  return rows.filter((row) => !isHiddenInternalEmail(row.email));
}
